(function ($){
    $(document).ready(function (){

        if (window.location.href.includes('/contact/') && window.location.search.includes('page_viewed')){
            var pageViewed = window.location.search.split('page_viewed=')[1];
            // console.log(pageViewed, 'search');
            $('input[name="input_6"]').val(pageViewed);
        }

        function detectMob() {
            const toMatch = [
                /Android/i,
                /webOS/i,
                /iPhone/i,
                /iPad/i,
                /iPod/i,
                /BlackBerry/i,
                /Windows Phone/i
            ];

            return toMatch.some((toMatchItem) => {
                return navigator.userAgent.match(toMatchItem);
            });
        }

        if (detectMob())$('body').addClass('mobile-version');

        //widget button target to form
        var $btxFooter = $('.btx-footer');
        var $btxSidebar = $('.btx-sidebar');

        //scroll to form
        $('#target-form').click(function (e){
            e.preventDefault();
            var linkContact = $(this).attr('href');
            window.location.href = window.location.origin + linkContact + '?page_viewed=' + window.location.href;
            // var linkTarget = $btxFooter;
            // $('html, body').stop().animate({scrollTop:linkTarget.offset().top}, 1000);
        });

        if ($btxSidebar.length > 0 && $btxFooter.length > 0 && !detectMob() && window.matchMedia("(min-width: 768px)").matches){

            //sticky widget
            function stickyWidget(){
                var widgetHtml = $('#widget-html').parent();
                var widgetHtmlParent = widgetHtml.parent();
                var widgetHtmlPosition = widgetHtmlParent.offset().top;
                var widgetContainer = $('aside.btx-sidebar');
                var widgetHtmlWidth = widgetContainer.width();
                var widgetHtmlHeight = widgetHtml.height();
                $btxFooter = $('.btx-footer');
                sectionFormPosition = $btxFooter.offset().top;

                // console.log(window.scrollY + widgetHtmlHeight + marginBottom , widgetHtmlPosition - marginTop, sectionFormPosition );

                if ( window.scrollY >= widgetHtmlPosition - marginTop  && window.scrollY + widgetHtmlHeight + marginBottom < sectionFormPosition ){
                    // console.log('fixed', window.scrollY + widgetHtmlHeight + marginBottom , sectionFormPosition, widgetHtmlPosition);
                    widgetHtml.attr('style','');
                    widgetHtml.css({
                        'position': 'fixed',
                        'top': marginTop + 'px',
                        'z-index': 1,
                        'width': widgetHtmlWidth + 'px'

                    });
                }else if (window.scrollY + widgetHtmlHeight + marginBottom >= sectionFormPosition ){
                    // console.log('absolute', window.scrollY + widgetHtmlHeight + marginBottom , sectionFormPosition, widgetHtmlPosition);
                    widgetHtml.attr('style','');
                    widgetHtml.css({
                        'position': 'absolute',
                        'bottom': '20px',
                        'z-index': 1,
                        'width': widgetHtmlWidth + 'px'
                    });
                    // $('html, body').stop();
                } else if (window.scrollY < widgetHtmlPosition - marginTop){
                    // console.log('static', window.scrollY , widgetHtmlPosition - marginTop, widgetHtmlPosition);
                    widgetHtml.attr('style','');
                    widgetHtml.css({
                        'position': 'static',
                        'top': '0px'
                    });
                }
            }




            var sectionFormPosition = $btxFooter.position().top;
            // widgetHtml.parent().height(widgetHtmlHeight).css('margin-bottom','20px');

            var marginTop = 80;
            var marginBottom = 120;

            new ResizeObserver(stickyWidget).observe($('body').get(0), $('.btx-sidebar').get(0));
            stickyWidget();

            $(window).scroll(function (){
                stickyWidget();
            });
        }
    });
})(jQuery)